// extracted by mini-css-extract-plugin
export default {"title":"_345d662105","bld":"_0ac5a16239"};